module.exports = __webpack_public_path__ + "static/media/joalisson.55e7539a.png";